import React from 'react';

import { InfoIcon } from '@pkg/assets/floorGame';

import { IconWrapper, StyledInfoAction } from './InfoAction.style';

export interface InfoActionProps {
    ariaLabel?: string;
    onAction: () => void;
}

// TODO: We may want to conslidate this with <InfoTooltipAction />
// and have one unified component that can either be a:
// 1. Hover + tooltip UI.
// 2. Click + modal/sheet UI.
export function InfoAction({ ariaLabel, onAction }: InfoActionProps) {
    return (
        <StyledInfoAction ariaLabel={ariaLabel} onAction={onAction}>
            <IconWrapper>
                <InfoIcon />
            </IconWrapper>
        </StyledInfoAction>
    );
}
